import { setComponentMapOverrides } from '@jutro/uiconfig';
import { PaymentDetailsPage, QualificationPage } from 'gw-capability-quoteandbind-common-react';
import 'gw-capability-quoteandbind-ba-react';
import GWQuoteBAPolicyDetailsPage from './pages/PolicyDetails/PolicyDetailsPage';

setComponentMapOverrides(
    {
        GWQuoteBAPolicyDetailsPage: { component: 'GWQuoteBAPolicyDetailsPage' },
        GWQuoteBAPaymentDetailsPage: { component: 'GWQuoteBAPaymentDetailsPage' },
        GWQuoteBAQualificationDetailsPage: { component: 'GWQuoteBAQualificationDetailsPage' }
    },
    {
        GWQuoteBAPolicyDetailsPage,
        GWQuoteBAPaymentDetailsPage: PaymentDetailsPage,
        GWQuoteBAQualificationDetailsPage: QualificationPage
    }
);

// eslint-disable-next-line import/prefer-default-export
export { default as PEBAWizard } from './PEBAWizard';
